import React, { useEffect, useState } from "react";
import { get, post } from '../../../Services/http';
import { PageHeaderWithButton } from "../../Components";
import { translate } from '../../../Services/translation';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import { CustomPastePlainText } from '../../Components/crud-component/CRUDFormField';

const StoreSettings = () => {
    const [storeClinicalPartPrice, setStoreClinicalPartPrice] = useState('');
    const [deviantOpeningHours, setdeviantOpeningHours] = useState("");
    const [error, seterror] = useState(false);

    useEffect(() => {
        get('api/storesettings/getstoresettings')
        .then((response) => response.json())
        .then((data) => {
            if (data.storeClinicalPartPrice !== null) {
                setStoreClinicalPartPrice(data.storeClinicalPartPrice);                
            }
            setdeviantOpeningHours(data.deviantOpeningHours);
        })
    }, []);

    const updateStoreSettings = () => {
        let tempStoreClinicalPrice = storeClinicalPartPrice !== '' ? storeClinicalPartPrice : null;
        post('api/storesettings/updatestoresettings', { 
            storeClinicalPartPrice: tempStoreClinicalPrice,
            deviantOpeningHours: deviantOpeningHours,
        })
        .then((result) => {
            if(result.ok) {
                location.reload();
            }
        })
        .catch((error) => {
            seterror(true);
            console.error("Something went wrong when updating store settings. Error: ", error);
        }) 
    }

    return (
        <div className="backend__settings">            
            <PageHeaderWithButton title={translate('coptikk.adminportal.storesettings')} btnText={translate('coptikk.adminportal.savebuttontext')} btnOnClick={() => updateStoreSettings()} />
            {error && <div className="error">{translate("coptikk.adminportal.storesettings.error")}</div>}
            <div className="row">
                <div className="columns small-12">
                    <div className="settings__field">
                        <div className="row settings__inner-row">
                            <div className="columns small-12"><h5>{translate('coptikk.adminportal.subscription')}</h5></div>
                            <div className="columns small-12">
                                <label>{translate('coptikk.adminportal.storesettings.storeclinicalpartprice')}<input type="number" min="0" name="storeClinicalPartPrice" value={storeClinicalPartPrice} onChange={(e) => {setStoreClinicalPartPrice(e.target.value)}}/></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="row backend__settings-deviantopening">
                <div className="columns small-12">
                    <label>{translate('coptikk.adminportal.storesettings.deviantopeninghours')} </label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={deviantOpeningHours || ''}
                        className="editor"
                        disabled={false}
                        onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new UploadAdapter(loader);

                        }}
                        config={{
                            toolbar: [
                                "selectAll",
                                "customPastePlainText",
                                "undo",
                                "redo",
                                "bold",
                                "italic",
                                "blockQuote",
                                "ckfinder",
                                "heading",
                                "indent",
                                "outdent",
                                "link",
                                "numberedList",
                                "bulletedList",
                            ],
                            image: {
                                // Configure the available styles.
                                styles: [],
                                sizes: [],
                                // You need to configure the image toolbar, too, so it shows the new style
                                // buttons as well as the resize buttons.
                                toolbar: [

                                ]
                            },
                            plugins: [
                                CustomPastePlainText,
                                Alignment,
                                Autoformat,
                                AutoLink,
                                Base64UploadAdapter,
                                BlockQuote,
                                Bold,
                                CloudServices,
                                Essentials,
                                Heading,
                                Indent,
                                Italic,
                                Paragraph,
                                PasteFromOffice,
                                TextTransformation,
                            ]
                        }}
                        onChange={(event, editor) => setdeviantOpeningHours(editor.getData())}
                    />
                </div>
            </div>
        </div>
    )
}

export default StoreSettings;
